import { defineComponent as Z, openBlock as r, createBlock as A, resolveDynamicComponent as J, createCommentVNode as F, defineAsyncComponent as se, computed as G, resolveComponent as me, mergeProps as Te, withCtx as ee, unref as oe, createElementBlock as d, Fragment as S, renderList as W, createVNode as P, createTextVNode as Me, toDisplayString as L, ref as H, onUnmounted as ce, normalizeClass as O, createElementVNode as b, shallowRef as he, watch as de, markRaw as $e, normalizeStyle as le, onMounted as Se, withModifiers as Y, Teleport as Be, Transition as Le, withKeys as ze, nextTick as Ie } from "vue";
import { Zap as Re, X as je, Search as Ee, Plus as Pe, Minus as Ne, Maximize as Ue, Loader2 as Ae, Lightbulb as Oe, Info as We, Image as De, Download as He, Copy as Ge, Check as qe, BarChart3 as Ke, AlertTriangle as Fe, AlertCircle as Xe } from "lucide-vue-next";
import fe from "mermaid";
import Ve from "katex";
import "katex/dist/katex.min.css";
function ge(t) {
  if (!t) return [];
  const e = [], a = [];
  let i = 0;
  const l = (o) => o.replace(/&quot;/g, '"').replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&#39;/g, "'").replace(/&#x27;/g, "'");
  for (; i < t.length; ) {
    const o = t.indexOf("<span", i), c = t.indexOf("</span>", i);
    if (o === -1 && c === -1) {
      const s = l(t.substring(i));
      if (s) {
        const m = { type: "text", content: s }, n = a[a.length - 1];
        n ? (n.node.children || (n.node.children = []), n.node.children.push(m)) : e.push(m);
      }
      break;
    }
    if (o !== -1 && (c === -1 || o < c)) {
      const s = l(t.substring(i, o));
      if (s) {
        const n = { type: "text", content: s }, u = a[a.length - 1];
        u ? (u.node.children || (u.node.children = []), u.node.children.push(n)) : e.push(n);
      }
      const m = t.substring(o).match(/<span[^>]*class="([^"]+)"[^>]*>/);
      if (m) {
        const u = {
          type: "span",
          className: m[1],
          children: []
        };
        a.push({ node: u }), i = o + m[0].length;
      } else
        i = o + 1;
    } else {
      const s = l(t.substring(i, c));
      if (s) {
        const m = { type: "text", content: s }, n = a[a.length - 1];
        n ? (n.node.children || (n.node.children = []), n.node.children.push(m)) : e.push(m);
      }
      if (a.length > 0) {
        const m = a.pop(), n = a[a.length - 1];
        n ? (n.node.children || (n.node.children = []), n.node.children.push(m.node)) : e.push(m.node);
      }
      i = c + 7;
    }
  }
  return e;
}
function pe() {
  return new RegExp("(?<!`)`(?!`)([^`\\n]+)`(?!`)", "g");
}
function ye() {
  return /\[[^\]]+\]\((?:<(?:(?:https?|mailto):[^>\n]+|(?:\/|\.\/|\.\.\/)[^>\n]+)>|(?:(?:https?|mailto):[^)\s]+|(?:\/|\.\/|\.\.\/)[^)\s]+))\)/g;
}
function be(t) {
  const e = String(t || "").trim();
  return /^(https?:|mailto:)/i.test(e) || /^(?:\/|\.\/|\.\.\/)[^\s]+$/.test(e) ? e : "";
}
function xe(t) {
  const e = String(t || "").match(/^\[([^\]]+)\]\((?:<([^>\n]+)>|([^)\s]+))\)$/);
  if (!e) return null;
  const a = be(e[2] || e[3]);
  return a ? { text: e[1] || "", href: a } : null;
}
function ke(t) {
  const e = String(t || "").match(/^([ \t]*)```([A-Za-z0-9_-]*)[ \t]*$/);
  return e ? {
    indent: e[1] || "",
    lang: e[2] || ""
  } : null;
}
function xn(t, e) {
  for (const a of String(t || "").split(`
`)) {
    const i = ke(a);
    if (i && (!e || e(i)))
      return !0;
  }
  return !1;
}
function Ze(t) {
  const e = t.split(`
`);
  let a = 1 / 0, i = 0;
  e.length > 0 && e[0] && e[0].trim() === "" && (i = 1);
  for (let o = i; o < e.length; o++) {
    const c = e[o];
    if (c && c.trim().length > 0) {
      const s = c.match(/^([ \t]*)/);
      if (s && s[1] !== void 0) {
        const m = s[1].length;
        m < a && (a = m);
      }
    }
  }
  let l = "";
  return a !== 1 / 0 && a > 0 ? l = e.map((o, c) => c < i || !o || o.trim().length === 0 ? "" : o.substring(a)).filter((o, c) => c >= i).join(`
`) : i > 0 ? l = e.slice(i).join(`
`) : l = t, l.trimEnd();
}
function ue(t, e, a = "normal", i = { enableKatex: !0, enableMermaid: !0, enableHighlight: !0 }) {
  if (!t) return [];
  let l = t.trim();
  const o = [], c = /(?:^|\n)([ \t]*)```(\w*)[ \t]*\n?([\s\S]*?)(?:\n\1```|$)/g, s = /(?:^|\n)\$\$([\s\S]*?)\$\$/g, m = [];
  let n;
  for (c.lastIndex = 0; (n = c.exec(l)) !== null; ) {
    const f = n[1] || "", p = n[2] || "", w = n[3] || "", h = Ze(w), x = p || "code";
    m.push({
      start: n.index,
      end: n.index + n[0].length,
      type: "code",
      data: { baseIndent: f, languageStr: x, processedCode: h }
    });
  }
  if (i.enableKatex)
    for (s.lastIndex = 0; (n = s.exec(l)) !== null; ) {
      const f = n[1] || "";
      m.some((p) => n.index >= p.start && n.index < p.end) || m.push({
        start: n.index,
        end: n.index + n[0].length,
        type: "katex",
        data: { formula: f.trim() }
      });
    }
  m.sort((f, p) => f.start - p.start);
  let u = 0;
  for (const f of m) {
    if (f.start > u) {
      const p = l.substring(u, f.start);
      o.push(...ie(p, e, a, i));
    }
    if (f.type === "code") {
      const { baseIndent: p, languageStr: w, processedCode: h } = f.data, x = w.toLowerCase();
      if (x === "mermaid" && i.enableMermaid)
        o.push({
          type: "mermaid",
          content: [],
          metadata: { language: w, rawCode: h, indent: p.length }
        });
      else {
        let y;
        (x === "text" || x === "markdown" || x === "" || x === "code") && (y = ie(h, e, "rich-text", i));
        const v = h.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        o.push({
          type: "code",
          content: ge(v),
          metadata: { language: w, rawCode: h, indent: p.length, richContent: y }
        });
      }
    } else f.type === "katex" && o.push({
      type: "katex",
      content: [],
      metadata: { rawCode: f.data.formula, indent: 0 }
    });
    u = f.end;
  }
  if (u < l.length) {
    const f = l.substring(u);
    o.push(...ie(f, e, a, i));
  }
  return o;
}
function ie(t, e, a = "normal", i = {}) {
  const l = t.split(`
`).map((n) => n.endsWith("\r") ? n.slice(0, -1) : n), o = [];
  let c = "", s = 0;
  const m = () => {
    c.trim() && (o.push({
      type: "text",
      // rich-text 模式下禁用 _italic_，避免 ASCII art 中的底線被誤判
      content: K(c, e, a === "rich-text", i),
      metadata: { level: s }
    }), c = "");
  };
  for (let n = 0; n < l.length; n++) {
    const u = l[n];
    if (u === void 0) continue;
    const f = u.trim();
    if (f === "") {
      c && (c += `
`);
      continue;
    }
    const p = u.match(/^(\s*)/), w = p ? p[0] : "", h = a === "rich-text" ? 0 : w.length >= 2 ? Math.floor(w.length / 2) : 0;
    if (a !== "rich-text" && /^\s*(-{3,}|\*{3,}|_{3,})\s*$/.test(u)) {
      m(), o.push({ type: "hr", content: [] });
      continue;
    }
    if (a !== "rich-text" && f.startsWith("|") && n + 1 < l.length) {
      const M = l[n + 1]?.trim() || "";
      if (M.startsWith("|") && /^[\|\s:\-]+$/.test(M)) {
        m();
        const I = (R) => {
          const C = "\0PIPE\0", $ = R.replace(/\\\|/g, C).split("|");
          let B = $[0]?.trim() === "" ? 1 : 0, j = $[$.length - 1]?.trim() === "" ? $.length - 1 : $.length;
          return $.slice(B, j).map((X) => X.trim().replaceAll(C, "|"));
        }, N = I(f).map((R) => K(R, e, !1, i)), q = I(M).map((R) => R.startsWith(":") && R.endsWith(":") ? "center" : R.endsWith(":") ? "right" : "left"), z = [];
        let E = n + 2;
        for (; E < l.length; ) {
          const R = l[E]?.trim();
          if (!R || !R.startsWith("|")) break;
          z.push(I(R).map((C) => K(C, e, !1, i))), E++;
        }
        o.push({
          type: "table",
          content: [],
          metadata: { headers: N, rows: z, aligns: q }
        }), n = E - 1;
        continue;
      }
    }
    const x = u.match(/^\s*(#{1,6})\s+(.+)$/);
    if (a !== "rich-text" && x) {
      m(), o.push({
        type: "header",
        content: K(x[2] || "", e, !1, i),
        metadata: { level: x[1]?.length || 3 }
      });
      continue;
    }
    const y = u.match(/^\s*\*\*([^\n]+?)\*\*\s*$/);
    if (y && a === "normal") {
      m(), o.push({
        type: "header",
        content: K(y[1] || "", e, !1, i),
        metadata: { level: 3 }
      });
      continue;
    }
    const v = u.match(/^(\s*)>\s?(.*)$/);
    if (a !== "rich-text" && v) {
      m();
      const M = v[1] || "", I = Math.floor(M.length / 2);
      let N = v[2] || "", q;
      const z = N.match(/^\[!(NOTE|TIP|IMPORTANT|WARNING|CAUTION)\]\s*(.*)$/i);
      z && (q = z[1]?.toUpperCase(), N = z[2] || "");
      let E = n + 1;
      for (; E < l.length; ) {
        const R = l[E];
        if (!R || !R.match(/^(\s*)>\s?(.*)$/)) break;
        const C = R.match(/^(\s*)>\s?(.*)$/)?.[1] || "";
        if (Math.floor(C.length / 2) !== I) break;
        N += `
` + (R.match(/^(\s*)>\s?(.*)$/)?.[2] || ""), E++;
      }
      n = E - 1, o.push({
        type: "blockquote",
        content: K(N, e, !1, i),
        metadata: { indent: M.length, level: I, alertType: q }
      });
      continue;
    }
    const T = u.match(/^(\s*)([\-\*]|\d+[\.\)]|[A-Za-z][\.\)])\s+(.*)$/);
    if (a !== "rich-text" && T) {
      m();
      const M = [];
      let I = n;
      for (; I < l.length; ) {
        const z = l[I];
        if (z === void 0) break;
        if (z.trim() === "") {
          I++;
          continue;
        }
        const E = z.trim(), R = E.startsWith("#") || E.startsWith(">") || E.startsWith("|") || /^(-{3,}|\*{3,}|_{3,})$/.test(E), C = z.match(/^(\s*)([\-\*]|\d+[\.\)]|[A-Za-z][\.\)])\s+(.*)$/);
        let $ = !1;
        if (C) {
          const B = (C[1] || "").length, j = M[M.length - 1];
          if (!j)
            $ = !0;
          else if (B <= j.baseIndent) {
            if (B < (M[0]?.baseIndent ?? 0))
              break;
            $ = !0;
          } else B > j.indentOffset ? $ = !1 : $ = !0;
        }
        if ($ && C) {
          const B = (C[1] || "").length, j = C[2] || "-", X = C[3] || "";
          let V = "", k = X, g = null;
          const D = X.match(/^\[([ xX])\]\s+(.*)$/);
          D && (g = D[1]?.toLowerCase() === "x", k = D[2] || "");
          const re = k.match(/^([A-Za-z\d]+[\.\)])\s+(.*)$/);
          re && (V = re[1] || "", k = re[2] || "");
          let te = "bullet";
          /\d+[\.\)]/.test(j) ? te = "number" : /[A-Za-z][\.\)]/.test(j) && (te = "alpha");
          const Ce = z.indexOf(X);
          M.push({
            contentLines: [k],
            marker: j,
            subMarker: V,
            listType: te,
            level: Math.floor(B / 2) + 1,
            indentOffset: Ce,
            baseIndent: B,
            checkbox: g
          });
        } else {
          if (M.length === 0) break;
          const B = M[M.length - 1];
          if (!B) break;
          const j = z.match(/^(\s*)/)?.[0].length || 0;
          if (j < B.indentOffset && R || j <= B.baseIndent && !C && E !== "")
            break;
          j >= B.indentOffset ? B.contentLines.push(z.substring(B.indentOffset)) : E !== "" && B.contentLines.push(E);
        }
        I++;
      }
      const N = M.map((z) => {
        const E = z.contentLines.join(`
`), C = z.listType === "number" || z.listType === "alpha" ? "ordered" : "bullet", $ = ue(E, e, "nested", i);
        return {
          marker: z.marker,
          subMarker: z.subMarker,
          content: $,
          level: z.level,
          listType: C,
          indent: z.baseIndent,
          checkbox: z.checkbox
        };
      }), q = N[0]?.listType || "bullet";
      n = I - 1, o.push({
        type: "list",
        content: [],
        metadata: {
          listType: q,
          items: N
        }
      });
      continue;
    }
    c && h !== s && m(), s = h, c += (c ? `
` : "") + (h > 0 ? u.substring(h * 2) : u);
  }
  return m(), o;
}
function K(t, e, a = !1, i = {}) {
  const l = [{ type: "text", content: t }], o = (n, u, f) => {
    for (let p = 0; p < l.length; p++) {
      const w = l[p];
      if (!w || w.type !== "text" || !w.content) continue;
      const h = w.content, x = Array.from(h.matchAll(n));
      if (x.length === 0) continue;
      const y = [];
      let v = 0;
      for (const T of x)
        T.index !== void 0 && (T.index > v && y.push({ type: "text", content: h.substring(v, T.index) }), f ? y.push(f(T)) : y.push({
          type: u,
          content: T[1] || T[0],
          children: u !== "inline-code" && u !== "link" && u !== "ref-link" ? K(T[1] || T[0], e, a, i) : void 0
        }), v = T.index + T[0].length);
      v < h.length && y.push({ type: "text", content: h.substring(v) }), l.splice(p, 1, ...y), p += y.length - 1;
    }
  };
  o(/\[\^(\d+)\]\((https?:\/\/[^\s)]+)\)/g, "ref-link", (n) => ({
    type: "ref-link",
    content: `[${n[1]}]`,
    href: n[2]
  }));
  const c = new RegExp("\\[ref:\\s*([\\d,\\s]+)\\]|(?<!__REF_)\\[(\\d+)\\]", "g");
  for (let n = 0; n < l.length; n++) {
    const u = l[n];
    if (!u || u.type !== "text" || !u.content) continue;
    const f = u.content, p = [];
    let w = 0;
    const h = Array.from(f.matchAll(c));
    if (h.length > 0) {
      for (const x of h) {
        if (x.index === void 0) continue;
        x.index > w && p.push({ type: "text", content: f.substring(w, x.index) });
        let y = [];
        x[1] ? y = x[1].split(",").map((v) => v.trim()).filter((v) => v) : x[2] && (y = [x[2]]), y.forEach((v) => {
          const T = e?.find((M) => M.id === v);
          T && T.url ? p.push({
            type: "ref-link",
            content: `[${v}]`,
            href: T.url.startsWith("http") ? T.url : `https://${T.url}`,
            title: T.title
          }) : p.push({ type: "text", content: `[${v}]` });
        }), w = x.index + x[0].length;
      }
      w < f.length && p.push({ type: "text", content: f.substring(w) }), l.splice(n, 1, ...p), n += p.length - 1;
    }
  }
  o(/\*\*([\s\S]+?)\*\*/g, "bold", (n) => ({
    type: "bold",
    children: K(n[1] || "", e, a, i)
  })), o(pe(), "inline-code", (n) => ({
    type: "inline-code",
    content: n[1]
  })), o(/!\[([^\]]*)\]\((https?:\/\/[^\s)]+|(?:\.|\.\.|\/)[^\s)]+)\)/g, "image", (n) => {
    const u = n[2] || "", f = u.startsWith("./") || u.startsWith("../") || u.startsWith("/");
    return {
      type: "image",
      alt: n[1] || "",
      src: u,
      isRelative: f
      // 標註為相對路徑資產
    };
  }), i.enableKatex !== !1 && o(new RegExp("(?<!\\\\)\\$((?:\\\\\\$|[^\\$\\n])+?)(?<!\\\\)\\$", "g"), "katex-inline", (n) => ({
    type: "katex-inline",
    formula: n[1]?.replace(/\\\$/g, "$") || ""
  })), o(ye(), "link", (n) => {
    const u = xe(n[0]), f = u?.href || "", w = (f.startsWith("./") || f.startsWith("../") || f.startsWith("/")) && /\.(ts|js|json|zip|pdf|docx?|xlsx?)$/i.test(f);
    return {
      type: "link",
      content: u?.text || n[0],
      href: f,
      isDownload: w,
      children: K(u?.text || "", e, a, i)
    };
  });
  const s = a ? new RegExp("(?<!\\*)\\*(?!\\*)([^*\\n]+?)\\*(?!\\*)", "g") : new RegExp("(?<!\\*)\\*(?!\\*)([^*\\n]+?)\\*(?!\\*)|(?<![\\w])_([^_\\n]+?)_(?![\\w])", "g");
  o(s, "italic", (n) => ({
    type: "italic",
    children: K(n[1] || n[2] || "", e, a, i)
  })), o(/~~([^~]+)~~/g, "strikethrough", (n) => ({
    type: "strikethrough",
    children: K(n[1] || "", e, a, i)
  }));
  const m = /(https?:\/\/[^\s<"\[\]']+)/g;
  for (let n = 0; n < l.length; n++) {
    const u = l[n];
    if (!u || u.type !== "text" || !u.content) continue;
    const f = Array.from(u.content.matchAll(m));
    if (f.length === 0) continue;
    const p = [];
    let w = 0;
    for (const h of f) {
      if (h.index === void 0) continue;
      h.index > w && p.push({ type: "text", content: u.content.substring(w, h.index) });
      const x = h[0], y = x.replace(/[.,)!?]+$/, ""), v = x.slice(y.length);
      p.push({
        type: "link",
        content: y,
        href: y,
        children: [{ type: "text", content: y }]
      }), v && p.push({ type: "text", content: v }), w = h.index + h[0].length;
    }
    w < u.content.length && p.push({ type: "text", content: u.content.substring(w) }), l.splice(n, 1, ...p), n += p.length - 1;
  }
  for (let n = 0; n < l.length; n++) {
    const u = l[n];
    if (u && u.type === "text" && u.content && u.content.includes(`
`)) {
      const f = u.content.split(`
`), p = [];
      f.forEach((w, h) => {
        w && p.push({ type: "text", content: w }), h < f.length - 1 && p.push({ type: "br" });
      }), l.splice(n, 1, ...p), n += p.length - 1;
    }
  }
  return l;
}
const Ye = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  parseMarkdown: ue
}, Symbol.toStringTag, { value: "Module" })), U = /* @__PURE__ */ Z({
  __name: "LucideIcon",
  props: {
    name: {},
    size: { default: 16 },
    strokeWidth: { default: 2 }
  },
  setup(t) {
    const e = {
      AlertCircle: Xe,
      AlertTriangle: Fe,
      BarChart3: Ke,
      Check: qe,
      Copy: Ge,
      Download: He,
      Image: De,
      Info: We,
      Lightbulb: Oe,
      Loader2: Ae,
      Maximize: Ue,
      Minus: Ne,
      Plus: Pe,
      Search: Ee,
      X: je,
      Zap: Re
    };
    return (a, i) => e[t.name] ? (r(), A(J(e[t.name]), {
      key: 0,
      size: t.size,
      "stroke-width": t.strokeWidth,
      "aria-hidden": "true"
    }, null, 8, ["size", "stroke-width"])) : F("", !0);
  }
}), _e = {
  key: 0,
  class: "ml-1 inline-flex items-center align-middle"
}, Q = /* @__PURE__ */ Z({
  name: "MarkdownResult",
  __name: "MarkdownResult",
  props: {
    node: {},
    accessToken: {},
    assetBaseUrl: {},
    downloadBaseUrl: {}
  },
  setup(t) {
    const e = se(() => import("./KatexInline-C4Yhg6lp.js")), a = t, i = G(() => {
      switch (a.node.type) {
        case "bold":
          return "strong";
        case "italic":
          return "em";
        case "strikethrough":
          return "del";
        case "link":
          return "a";
        case "ref-link":
          return "a";
        case "inline-code":
          return "code";
        case "image":
          return "img";
        case "br":
          return "br";
        case "span":
          return "span";
        case "text":
          return "span";
        case "katex-inline":
          return "span";
        default:
          return "span";
      }
    }), l = G(() => {
      const c = {};
      if (a.node.type === "link" || a.node.type === "ref-link") {
        let s = a.node.href || "";
        if (a.node.isDownload) {
          const m = s.split("/").pop() || "";
          let n = a.downloadBaseUrl ? `${a.downloadBaseUrl.replace(/\/$/, "")}/${m}` : s;
          a.accessToken && (n += `?token=${a.accessToken}`), c.href = n, c.download = m, c.target = "_self";
        } else
          c.href = s, c.target = "_blank";
        c.rel = "noopener noreferrer", a.node.title && (c.title = a.node.title);
      }
      if (a.node.type === "image") {
        let s = a.node.src || "";
        if (a.node.isRelative) {
          const m = s.replace(/^\.\//, "");
          let n = a.assetBaseUrl ? `${a.assetBaseUrl.replace(/\/$/, "")}/${m}` : s;
          a.accessToken && (n += `?token=${a.accessToken}`), c.src = n;
        } else
          c.src = s;
        c.alt = a.node.alt, a.node.title && (c.title = a.node.title), c.loading = "lazy";
      }
      return a.node.className && (c.class = a.node.className), c;
    }), o = G(() => {
      switch (a.node.type) {
        case "bold":
          return "font-bold";
        case "link": {
          const c = "hover:text-blue-600 underline decoration-blue-300 dark:decoration-blue-700 underline-offset-2 transition-colors cursor-pointer";
          return a.node.isDownload ? `text-emerald-500 hover:text-emerald-600 decoration-emerald-300 ${c}` : `text-blue-500 ${c}`;
        }
        case "ref-link":
          return "text-xs font-mono text-blue-500 hover:text-blue-600 bg-blue-50 dark:bg-blue-900/20 align-super no-underline hover:underline transition-colors cursor-pointer";
        case "inline-code":
          return "font-mono text-[0.9em] bg-gray-100 dark:bg-dark-100 text-primary dark:text-primary-400 px-1.5 py-0.5 rounded border border-gray-200 dark:border-dark-200";
        case "image":
          return "max-w-full h-auto rounded-lg border border-gray-200 dark:border-dark-200 shadow-sm inline-block my-1";
        case "katex-inline":
          return "inline-block px-1";
        default:
          return "";
      }
    });
    return (c, s) => {
      const m = me("MarkdownResult", !0);
      return r(), A(J(i.value), Te(l.value, { class: o.value }), {
        default: ee(() => [
          t.node.type === "katex-inline" ? (r(), A(oe(e), {
            key: 0,
            formula: t.node.formula
          }, null, 8, ["formula"])) : t.node.children && t.node.children.length > 0 ? (r(), d(S, { key: 1 }, [
            (r(!0), d(S, null, W(t.node.children, (n, u) => (r(), A(m, {
              key: u,
              node: n,
              "access-token": t.accessToken
            }, null, 8, ["node", "access-token"]))), 128)),
            t.node.isDownload ? (r(), d("span", _e, [
              P(U, {
                name: "Download",
                size: 12,
                class: "opacity-70"
              })
            ])) : F("", !0)
          ], 64)) : t.node.content ? (r(), d(S, { key: 2 }, [
            Me(L(t.node.content), 1)
          ], 64)) : F("", !0)
        ]),
        _: 1
      }, 16, ["class"]);
    };
  }
}), Je = { class: "markdown-renderer-container w-full" }, Qe = {
  key: 0,
  class: "mt-1 flex justify-center items-start min-w-6 shrink-0"
}, et = {
  key: 1,
  class: "mt-0.5 text-[14px] font-bold text-gray-600 dark:text-gray-400 min-w-6 text-right shrink-0 font-mono pr-1"
}, tt = {
  key: 2,
  class: "mt-1 flex justify-center items-start min-w-6 shrink-0"
}, nt = {
  key: 3,
  class: "mt-0.5 text-[14px] font-bold text-gray-600 dark:text-gray-400 min-w-6 text-right shrink-0 font-mono pr-1"
}, at = { class: "flex-1 text-[15px] text-gray-700 dark:text-gray-300 leading-relaxed wrap-break-word whitespace-pre-wrap" }, rt = { class: "flex justify-end items-center h-8 px-3 bg-gray-100/80 dark:bg-dark-100/50 border-b border-gray-200 dark:border-dark-200" }, st = ["onClick"], ot = { class: "overflow-x-auto custom-scrollbar" }, lt = { class: "min-w-full divide-y divide-gray-200 dark:divide-dark-300 text-[14px]" }, it = { class: "bg-gray-100/80 dark:bg-dark-100/50" }, ct = { class: "bg-white dark:bg-dark-100 divide-y divide-gray-200 dark:divide-dark-300" }, dt = /* @__PURE__ */ Z({
  name: "MarkdownRenderer",
  __name: "MarkdownRenderer",
  props: {
    content: {},
    source: {},
    blocks: {},
    references: {},
    isCompact: { type: Boolean },
    config: {},
    accessToken: {},
    assetBaseUrl: {},
    downloadBaseUrl: {},
    notifySuccess: { type: Function },
    notifyError: { type: Function }
  },
  setup(t) {
    const e = se(() => Promise.resolve().then(() => Kt)), a = se(() => Promise.resolve().then(() => ln)), i = se(() => Promise.resolve().then(() => fn)), l = t, o = H(null);
    let c = null;
    function s(f) {
      return f.map((p) => p.type === "text" ? p.content || "" : p.children ? s(p.children) : p.content || "").join("");
    }
    async function m(f, p) {
      const w = f.metadata?.headers || [], h = f.metadata?.rows || [], x = f.metadata?.aligns || [], y = "| " + w.map((M) => s(M)).join(" | ") + " |", v = "| " + w.map((M, I) => {
        const N = x[I];
        return N === "center" ? ":---:" : N === "right" ? "---:" : "---";
      }).join(" | ") + " |", T = h.map((M) => "| " + M.map((I) => s(I)).join(" | ") + " |");
      try {
        await navigator.clipboard.writeText([y, v, ...T].join(`
`)), o.value = p, c && clearTimeout(c), c = setTimeout(() => {
          o.value = null;
        }, 2e3);
      } catch {
      }
    }
    ce(() => {
      c && clearTimeout(c);
    });
    const n = G(() => l.blocks ? l.blocks : ue(
      l.content ?? l.source ?? "",
      l.references,
      l.isCompact ? "nested" : "normal",
      l.config
    )), u = (f) => {
      switch (f) {
        case "NOTE":
          return "Info";
        case "TIP":
          return "Lightbulb";
        case "IMPORTANT":
          return "AlertCircle";
        case "WARNING":
          return "AlertTriangle";
        case "CAUTION":
          return "Zap";
        default:
          return "Info";
      }
    };
    return (f, p) => {
      const w = me("MarkdownRenderer", !0);
      return r(), d("div", Je, [
        (r(!0), d(S, null, W(n.value, (h, x) => (r(), d(S, { key: x }, [
          h.type === "header" ? (r(), A(J("h" + (h.metadata?.level || 3)), {
            key: 0,
            class: O([
              h.metadata?.level === 1 ? "text-2xl" : h.metadata?.level === 2 ? "text-xl" : "text-lg",
              "font-bold text-gray-800 dark:text-gray-100 leading-tight",
              x === 0 ? "mt-0" : t.isCompact ? "mt-2" : "mt-4",
              x === n.value.length - 1 ? "mb-0" : t.isCompact ? "mb-1" : "mb-2"
            ])
          }, {
            default: ee(() => [
              (r(!0), d(S, null, W(h.content, (y, v) => (r(), A(Q, {
                key: v,
                node: y,
                "access-token": t.accessToken,
                "asset-base-url": t.assetBaseUrl,
                "download-base-url": t.downloadBaseUrl
              }, null, 8, ["node", "access-token", "asset-base-url", "download-base-url"]))), 128))
            ]),
            _: 2
          }, 1032, ["class"])) : h.type === "hr" ? (r(), d("hr", {
            key: 1,
            class: O([
              x === 0 ? "mt-0" : "mt-4",
              "border-t border-gray-200 dark:border-dark-200",
              x === n.value.length - 1 ? "mb-0" : "mb-4"
            ])
          }, null, 2)) : h.type === "blockquote" ? (r(), d("blockquote", {
            key: 2,
            class: O([
              "pl-3 border-l-4 italic text-gray-700 dark:text-gray-300 leading-relaxed whitespace-pre-wrap relative",
              h.metadata?.alertType ? h.metadata.alertType === "NOTE" ? "border-blue-500 bg-blue-50/50 dark:bg-blue-500/5 py-2 pr-3" : h.metadata.alertType === "TIP" ? "border-emerald-500 bg-emerald-50/50 dark:bg-emerald-500/5 py-2 pr-3" : h.metadata.alertType === "IMPORTANT" ? "border-purple-500 bg-purple-50/50 dark:bg-purple-500/5 py-2 pr-3" : h.metadata.alertType === "WARNING" ? "border-amber-500 bg-amber-50/50 dark:bg-amber-500/5 py-2 pr-3" : "border-red-500 bg-red-50/50 dark:bg-red-500/5 py-2 pr-3" : "border-gray-300 dark:border-dark-200",
              x === n.value.length - 1 ? "mb-0" : t.isCompact ? "mb-1.5" : "mb-3",
              (h.metadata?.level || 0) === 1 ? "ml-2" : (h.metadata?.level || 0) === 2 ? "ml-6" : (h.metadata?.level || 0) >= 3 ? "ml-10" : ""
            ])
          }, [
            h.metadata?.alertType ? (r(), d("div", {
              key: 0,
              class: O([
                "flex items-center gap-2 mb-1 not-italic font-bold text-xs tracking-wide",
                h.metadata.alertType === "NOTE" ? "text-blue-600 dark:text-blue-400" : h.metadata.alertType === "TIP" ? "text-emerald-600 dark:text-emerald-400" : h.metadata.alertType === "IMPORTANT" ? "text-purple-600 dark:text-purple-400" : h.metadata.alertType === "WARNING" ? "text-amber-600 dark:text-amber-400" : "text-red-600 dark:text-red-400"
              ])
            }, [
              P(U, {
                name: u(h.metadata.alertType),
                size: 14
              }, null, 8, ["name"]),
              b("span", null, L(h.metadata.alertType), 1)
            ], 2)) : F("", !0),
            (r(!0), d(S, null, W(h.content, (y, v) => (r(), A(Q, {
              key: v,
              node: y,
              "access-token": t.accessToken,
              "asset-base-url": t.assetBaseUrl,
              "download-base-url": t.downloadBaseUrl
            }, null, 8, ["node", "access-token", "asset-base-url", "download-base-url"]))), 128))
          ], 2)) : h.type === "list" ? (r(), A(J(h.metadata?.listType === "ordered" ? "ol" : "ul"), {
            key: 3,
            class: O([
              "space-y-1.5",
              x === n.value.length - 1 ? "mb-0" : t.isCompact ? "mb-1.5" : "mb-3"
            ])
          }, {
            default: ee(() => [
              (r(!0), d(S, null, W(h.metadata?.items, (y, v) => (r(), d("li", {
                key: v,
                class: O([
                  "flex items-start gap-1",
                  y.level === 2 ? "ml-4" : y.level === 3 ? "ml-8" : y.level >= 4 ? "ml-12" : ""
                ])
              }, [
                y.checkbox !== null && y.checkbox !== void 0 ? (r(), d("div", Qe, [
                  b("div", {
                    class: O([
                      "w-4 h-4 rounded border flex items-center justify-center transition-colors",
                      y.checkbox ? "bg-blue-500 border-blue-500 text-white" : "bg-transparent border-gray-300 dark:border-dark-300"
                    ])
                  }, [
                    y.checkbox ? (r(), A(U, {
                      key: 0,
                      name: "Check",
                      size: 12,
                      "stroke-width": 3
                    })) : F("", !0)
                  ], 2)
                ])) : y.subMarker ? (r(), d("div", et, L(y.subMarker), 1)) : y.listType === "bullet" ? (r(), d("div", tt, [...p[0] || (p[0] = [
                  b("div", { class: "mt-1.5 w-1.5 h-1.5 rounded-full bg-gray-400 dark:bg-gray-500" }, null, -1)
                ])])) : (r(), d("div", nt, L(y.marker), 1)),
                b("div", at, [
                  P(w, {
                    blocks: y.content,
                    isCompact: !0,
                    config: l.config,
                    "access-token": t.accessToken,
                    "asset-base-url": t.assetBaseUrl,
                    "download-base-url": t.downloadBaseUrl,
                    "notify-success": t.notifySuccess,
                    "notify-error": t.notifyError
                  }, null, 8, ["blocks", "config", "access-token", "asset-base-url", "download-base-url", "notify-success", "notify-error"])
                ])
              ], 2))), 128))
            ]),
            _: 2
          }, 1032, ["class"])) : h.type === "code" ? (r(), A(oe(e), {
            key: 4,
            block: h,
            index: x,
            "blocks-count": n.value.length,
            "access-token": t.accessToken,
            "asset-base-url": t.assetBaseUrl,
            "download-base-url": t.downloadBaseUrl,
            "notify-error": t.notifyError
          }, null, 8, ["block", "index", "blocks-count", "access-token", "asset-base-url", "download-base-url", "notify-error"])) : h.type === "mermaid" ? (r(), A(oe(a), {
            key: 5,
            block: h,
            index: x,
            "blocks-count": n.value.length,
            "notify-success": t.notifySuccess,
            "notify-error": t.notifyError
          }, null, 8, ["block", "index", "blocks-count", "notify-success", "notify-error"])) : h.type === "katex" ? (r(), A(oe(i), {
            key: 6,
            block: h,
            index: x,
            "blocks-count": n.value.length
          }, null, 8, ["block", "index", "blocks-count"])) : h.type === "table" ? (r(), d("div", {
            key: 7,
            class: O([
              "table-wrapper relative overflow-hidden rounded-xl border border-gray-200 dark:border-dark-200 shadow-sm",
              x === n.value.length - 1 ? "mb-0" : "mb-4"
            ])
          }, [
            b("div", rt, [
              b("button", {
                onClick: (y) => m(h, x),
                class: "text-gray-400 dark:text-gray-400 hover:text-gray-700 dark:hover:text-white transition-all inline-flex items-center justify-center gap-1 text-[11px] font-bold h-6 px-2 rounded hover:bg-black/5 dark:hover:bg-white/10 active:scale-95"
              }, [
                o.value === x ? (r(), d(S, { key: 0 }, [
                  P(U, {
                    name: "Check",
                    size: 12,
                    class: "text-green-500"
                  }),
                  p[1] || (p[1] = b("span", { class: "text-green-500" }, "已複製", -1))
                ], 64)) : (r(), d(S, { key: 1 }, [
                  P(U, {
                    name: "Copy",
                    size: 12
                  }),
                  p[2] || (p[2] = b("span", null, "複製", -1))
                ], 64))
              ], 8, st)
            ]),
            b("div", ot, [
              b("table", lt, [
                b("thead", it, [
                  b("tr", null, [
                    (r(!0), d(S, null, W(h.metadata?.headers, (y, v) => (r(), d("th", {
                      key: v,
                      class: O([
                        "px-4 py-3 font-bold text-gray-900 dark:text-gray-100 tracking-tight whitespace-nowrap",
                        h.metadata?.aligns?.[v] === "center" ? "text-center" : h.metadata?.aligns?.[v] === "right" ? "text-right" : "text-left"
                      ])
                    }, [
                      (r(!0), d(S, null, W(y, (T, M) => (r(), A(Q, {
                        key: M,
                        node: T,
                        "access-token": t.accessToken,
                        "asset-base-url": t.assetBaseUrl,
                        "download-base-url": t.downloadBaseUrl
                      }, null, 8, ["node", "access-token", "asset-base-url", "download-base-url"]))), 128))
                    ], 2))), 128))
                  ])
                ]),
                b("tbody", ct, [
                  (r(!0), d(S, null, W(h.metadata?.rows, (y, v) => (r(), d("tr", {
                    key: v,
                    class: "even:bg-gray-50/80 dark:even:bg-gray-800/20 hover:bg-blue-50/50 dark:hover:bg-blue-900/10 transition-colors"
                  }, [
                    (r(!0), d(S, null, W(y, (T, M) => (r(), d("td", {
                      key: M,
                      class: O([
                        "px-4 py-2.5 text-gray-600 dark:text-gray-300",
                        // 如果內容包含 _id 或 fileId 等可能是 ID 的文字，或內容較短，則不換行
                        M === 0 || M === 1 ? "whitespace-nowrap" : "min-w-[120px]",
                        h.metadata?.aligns?.[M] === "center" ? "text-center" : h.metadata?.aligns?.[M] === "right" ? "text-right" : "text-left"
                      ])
                    }, [
                      (r(!0), d(S, null, W(T, (I, N) => (r(), A(Q, {
                        key: N,
                        node: I,
                        "access-token": t.accessToken,
                        "asset-base-url": t.assetBaseUrl,
                        "download-base-url": t.downloadBaseUrl
                      }, null, 8, ["node", "access-token", "asset-base-url", "download-base-url"]))), 128))
                    ], 2))), 128))
                  ]))), 128))
                ])
              ])
            ]),
            p[3] || (p[3] = b("div", { class: "absolute inset-y-0 right-0 w-8 bg-gradient-to-l from-black/5 to-transparent pointer-events-none opacity-0 sm:opacity-100 transition-opacity" }, null, -1))
          ], 2)) : (r(), d("div", {
            key: 8,
            class: O([
              "text-block leading-relaxed text-[15px] text-gray-700 dark:text-gray-300 whitespace-pre-wrap",
              x === n.value.length - 1 ? "mb-0" : t.isCompact ? "mb-1.5" : "mb-3",
              (h.metadata?.level || 0) === 1 ? "ml-4" : (h.metadata?.level || 0) === 2 ? "ml-8" : (h.metadata?.level || 0) >= 3 ? "ml-12" : ""
            ])
          }, [
            (r(!0), d(S, null, W(h.content, (y, v) => (r(), A(Q, {
              key: v,
              node: y,
              "access-token": t.accessToken,
              "asset-base-url": t.assetBaseUrl,
              "download-base-url": t.downloadBaseUrl
            }, null, 8, ["node", "access-token", "asset-base-url", "download-base-url"]))), 128))
          ], 2))
        ], 64))), 128))
      ]);
    };
  }
}), ae = (t, e) => {
  const a = t.__vccOpts || t;
  for (const [i, l] of e)
    a[i] = l;
  return a;
}, ve = /* @__PURE__ */ ae(dt, [["__scopeId", "data-v-0208a3d5"]]), ut = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ve
}, Symbol.toStringTag, { value: "Module" })), kn = /* @__PURE__ */ Z({
  __name: "MarkdownAdaptiveRenderer",
  props: {
    content: { default: "" },
    source: { default: "" },
    blocks: { default: void 0 },
    references: { default: () => [] },
    isCompact: { type: Boolean, default: !1 },
    config: { default: void 0 },
    updateMode: { default: void 0 },
    liveRenderMode: { default: void 0 },
    liveThrottleMs: { default: void 0 },
    streaming: { type: Boolean, default: !1 },
    streamingRenderMode: { default: "throttled" },
    streamingThrottleMs: { default: 250 },
    liveClass: { default: "" },
    cacheLimit: { default: 80 },
    accessToken: { default: void 0 },
    assetBaseUrl: { default: void 0 },
    downloadBaseUrl: { default: void 0 },
    notifySuccess: { type: Function, default: void 0 },
    notifyError: { type: Function, default: void 0 }
  },
  setup(t) {
    const e = t, a = /* @__PURE__ */ new Map();
    let i = null;
    const l = he(null);
    let o = null;
    function c() {
      return i ||= Promise.resolve().then(() => Ye), i;
    }
    function s() {
      return o ||= Promise.resolve().then(() => ut).then((C) => (l.value = $e(C.default), C.default)), o;
    }
    function m(C, $, B, j) {
      return JSON.stringify({ content: C, references: $, context: B, config: j });
    }
    function n(C, $) {
      if (!(e.cacheLimit <= 0))
        for (a.has(C) && a.delete(C), a.set(C, $); a.size > e.cacheLimit; ) {
          const B = a.keys().next().value;
          if (B == null) break;
          a.delete(B);
        }
    }
    function u(C) {
      return C ? [{ type: "text", content: [{ type: "text", content: C }], metadata: { level: 0 } }] : [];
    }
    const f = G(() => e.content || e.source || ""), p = G(() => e.isCompact ? "nested" : "normal"), w = G(() => e.updateMode ?? (e.streaming ? "live" : "stable")), h = G(() => e.liveRenderMode ?? e.streamingRenderMode), x = G(() => e.liveThrottleMs ?? e.streamingThrottleMs), y = G(() => w.value === "live"), v = G(() => ({
      enableHighlight: e.config?.enableHighlight !== !1,
      enableKatex: e.config?.enableKatex !== !1,
      enableMermaid: e.config?.enableMermaid !== !1
    })), T = he([]), M = G(() => !!(f.value && (!T.value.length || !l.value)));
    let I = 0, N = null, q = 0;
    function z() {
      N && (clearTimeout(N), N = null);
    }
    function E(C) {
      z();
      const $ = Math.max(50, x.value), B = performance.now() - q;
      if (B >= $) {
        C();
        return;
      }
      N = setTimeout(C, $ - B);
    }
    de(
      () => [
        f.value,
        e.blocks,
        e.references,
        e.isCompact,
        w.value,
        h.value,
        x.value,
        v.value.enableHighlight,
        v.value.enableKatex,
        v.value.enableMermaid,
        e.cacheLimit
      ],
      async () => {
        const C = ++I;
        if (e.blocks) {
          T.value = e.blocks, s();
          return;
        }
        const $ = f.value;
        if (!$) {
          T.value = [];
          return;
        }
        if (y.value && h.value === "text") {
          T.value = [];
          return;
        }
        if (y.value) {
          E(() => {
            C === I && R(C, $);
          });
          return;
        }
        T.value = [], await R(C, $);
      },
      { immediate: !0 }
    );
    async function R(C, $) {
      q = performance.now();
      const B = v.value, j = m($, e.references, p.value, B), V = !y.value && e.cacheLimit > 0 ? a.get(j) : void 0;
      if (V) {
        a.delete(j), a.set(j, V), T.value = V, s();
        return;
      }
      try {
        const [{ parseMarkdown: k }] = await Promise.all([c(), s()]);
        if (C !== I) return;
        const g = k($, e.references, p.value, B);
        y.value || n(j, g), T.value = g;
      } catch {
        const k = u($);
        y.value || n(j, k), T.value = k;
      }
    }
    return ce(z), (C, $) => M.value ? (r(), d("div", {
      key: 0,
      class: O(["whitespace-pre-wrap break-words", t.liveClass])
    }, L(f.value), 3)) : T.value.length && l.value ? (r(), A(J(l.value), {
      key: 1,
      blocks: T.value,
      references: t.references,
      "is-compact": t.isCompact,
      config: v.value,
      "access-token": t.accessToken,
      "asset-base-url": t.assetBaseUrl,
      "download-base-url": t.downloadBaseUrl,
      "notify-success": t.notifySuccess,
      "notify-error": t.notifyError
    }, null, 8, ["blocks", "references", "is-compact", "config", "access-token", "asset-base-url", "download-base-url", "notify-success", "notify-error"])) : F("", !0);
  }
}), ht = 200;
function vn(t) {
  return be(t);
}
function ne(t) {
  const e = [], a = new RegExp(`${pe().source}|\\*\\*[^*]+\\*\\*|\\*[^*]+\\*|${ye().source}`, "g");
  let i = 0, l, o = 0;
  for (; (l = a.exec(t)) && o < ht; ) {
    o += 1, l.index > i && e.push({ type: "text", text: t.slice(i, l.index) });
    const c = l[0];
    if (c.startsWith("`"))
      e.push({ type: "code", text: c.slice(1, -1) });
    else if (c.startsWith("**"))
      e.push({ type: "bold", text: c.slice(2, -2) });
    else if (c.startsWith("*"))
      e.push({ type: "italic", text: c.slice(1, -1) });
    else {
      const s = xe(c);
      e.push(s ? { type: "link", text: s.text, href: s.href } : { type: "text", text: c });
    }
    i = a.lastIndex;
  }
  return i < t.length && e.push({ type: "text", text: t.slice(i) }), e.length ? e : [{ type: "text", text: t }];
}
function _(t, e) {
  e.length && (t.push({ type: "paragraph", tokens: ne(e.join(`
`)) }), e.length = 0);
}
function ft(t) {
  const e = [], a = [], i = String(t || "").replace(/\r\n/g, `
`).split(`
`);
  let l = !1, o = "", c = [];
  for (const s of i) {
    const m = ke(s);
    if (m) {
      l ? (e.push({ type: "code", lang: o || "code", text: c.join(`
`) }), l = !1, o = "", c = []) : (_(e, a), l = !0, o = m.lang);
      continue;
    }
    if (l) {
      c.push(s);
      continue;
    }
    if (!s.trim()) {
      _(e, a);
      continue;
    }
    const n = s.match(/^(#{1,6})\s+(.+)$/);
    if (n) {
      _(e, a), e.push({ type: "heading", level: n[1].length, tokens: ne(n[2]) });
      continue;
    }
    if (/^\s*(-{3,}|\*{3,}|_{3,})\s*$/.test(s)) {
      _(e, a), e.push({ type: "hr" });
      continue;
    }
    const u = s.match(/^>\s?(.*)$/);
    if (u) {
      _(e, a), e.push({ type: "quote", tokens: ne(u[1]) });
      continue;
    }
    const f = s.match(/^\s*(([-*+])|(\d+)[.)])\s+(.+)$/);
    if (f) {
      _(e, a);
      const p = e[e.length - 1], w = !!f[3], h = w ? Number.parseInt(f[3], 10) : void 0;
      p?.type === "list" && p.ordered === w ? p.items.push(ne(f[4])) : e.push({ type: "list", ordered: w, start: h, items: [ne(f[4])] });
      continue;
    }
    a.push(s);
  }
  return l && e.push({ type: "code", lang: o || "code", text: c.join(`
`) }), _(e, a), e;
}
const mt = {
  key: 0,
  class: "luna-light-inline-code"
}, gt = { key: 1 }, pt = { key: 2 }, yt = ["href"], bt = { key: 4 }, xt = {
  key: 1,
  class: "luna-light-paragraph"
}, kt = {
  key: 0,
  class: "luna-light-inline-code"
}, vt = { key: 1 }, wt = { key: 2 }, Ct = ["href"], Tt = { key: 4 }, Mt = {
  key: 2,
  class: "luna-light-quote"
}, $t = {
  key: 0,
  class: "luna-light-inline-code"
}, St = { key: 1 }, Bt = { key: 2 }, Lt = ["href"], zt = { key: 4 }, It = {
  key: 0,
  class: "luna-light-inline-code"
}, Rt = { key: 1 }, jt = { key: 2 }, Et = ["href"], Pt = { key: 4 }, Nt = {
  key: 4,
  class: "luna-light-code"
}, Ut = {
  key: 5,
  class: "luna-light-hr"
}, At = /* @__PURE__ */ Z({
  __name: "LightMarkdownRenderer",
  props: {
    content: { default: "" },
    compact: { type: Boolean, default: !1 }
  },
  setup(t) {
    const e = t, a = G(() => ft(e.content));
    return (i, l) => (r(), d("div", {
      class: O(["luna-light-markdown", { "luna-light-markdown-compact": t.compact }])
    }, [
      (r(!0), d(S, null, W(a.value, (o, c) => (r(), d(S, { key: c }, [
        o.type === "heading" ? (r(), A(J(`h${Math.min(o.level || 2, 6)}`), {
          key: 0,
          class: "luna-light-heading"
        }, {
          default: ee(() => [
            (r(!0), d(S, null, W(o.tokens, (s, m) => (r(), d(S, { key: m }, [
              s.type === "code" ? (r(), d("code", mt, L(s.text), 1)) : s.type === "bold" ? (r(), d("strong", gt, L(s.text), 1)) : s.type === "italic" ? (r(), d("em", pt, L(s.text), 1)) : s.type === "link" ? (r(), d("a", {
                key: 3,
                href: s.href,
                target: "_blank",
                rel: "noreferrer"
              }, L(s.text), 9, yt)) : (r(), d("span", bt, L(s.text), 1))
            ], 64))), 128))
          ]),
          _: 2
        }, 1024)) : o.type === "paragraph" ? (r(), d("p", xt, [
          (r(!0), d(S, null, W(o.tokens, (s, m) => (r(), d(S, { key: m }, [
            s.type === "code" ? (r(), d("code", kt, L(s.text), 1)) : s.type === "bold" ? (r(), d("strong", vt, L(s.text), 1)) : s.type === "italic" ? (r(), d("em", wt, L(s.text), 1)) : s.type === "link" ? (r(), d("a", {
              key: 3,
              href: s.href,
              target: "_blank",
              rel: "noreferrer"
            }, L(s.text), 9, Ct)) : (r(), d("span", Tt, L(s.text), 1))
          ], 64))), 128))
        ])) : o.type === "quote" ? (r(), d("blockquote", Mt, [
          (r(!0), d(S, null, W(o.tokens, (s, m) => (r(), d(S, { key: m }, [
            s.type === "code" ? (r(), d("code", $t, L(s.text), 1)) : s.type === "bold" ? (r(), d("strong", St, L(s.text), 1)) : s.type === "italic" ? (r(), d("em", Bt, L(s.text), 1)) : s.type === "link" ? (r(), d("a", {
              key: 3,
              href: s.href,
              target: "_blank",
              rel: "noreferrer"
            }, L(s.text), 9, Lt)) : (r(), d("span", zt, L(s.text), 1))
          ], 64))), 128))
        ])) : o.type === "list" ? (r(), A(J(o.ordered ? "ol" : "ul"), {
          key: 3,
          class: "luna-light-list",
          start: o.ordered ? o.start : void 0
        }, {
          default: ee(() => [
            (r(!0), d(S, null, W(o.items, (s, m) => (r(), d("li", { key: m }, [
              (r(!0), d(S, null, W(s, (n, u) => (r(), d(S, { key: u }, [
                n.type === "code" ? (r(), d("code", It, L(n.text), 1)) : n.type === "bold" ? (r(), d("strong", Rt, L(n.text), 1)) : n.type === "italic" ? (r(), d("em", jt, L(n.text), 1)) : n.type === "link" ? (r(), d("a", {
                  key: 3,
                  href: n.href,
                  target: "_blank",
                  rel: "noreferrer"
                }, L(n.text), 9, Et)) : (r(), d("span", Pt, L(n.text), 1))
              ], 64))), 128))
            ]))), 128))
          ]),
          _: 2
        }, 1032, ["start"])) : o.type === "code" ? (r(), d("pre", Nt, [
          b("code", null, L(o.text), 1)
        ])) : o.type === "hr" ? (r(), d("hr", Ut)) : F("", !0)
      ], 64))), 128))
    ], 2));
  }
}), wn = /* @__PURE__ */ ae(At, [["__scopeId", "data-v-1eed78da"]]), Ot = { class: "code-header flex justify-between items-center h-10 px-4 bg-gray-100/80 dark:bg-dark-100/50 border-b border-gray-200 dark:border-dark-200 no-select" }, Wt = { class: "flex items-center gap-2.5 shrink-0" }, Dt = { class: "text-[11px] font-bold uppercase text-gray-500 dark:text-gray-400 tracking-wider ml-1.5 whitespace-nowrap" }, Ht = {
  key: 1,
  class: "whitespace-pre"
}, Gt = /* @__PURE__ */ Z({
  __name: "CodeBlock",
  props: {
    block: {},
    index: {},
    blocksCount: {},
    accessToken: {},
    assetBaseUrl: {},
    downloadBaseUrl: {},
    notifyError: { type: Function }
  },
  setup(t) {
    const e = t, a = H(!1), i = H(e.block.content);
    let l = 0;
    de(
      () => [
        e.block.metadata?.rawCode || "",
        e.block.metadata?.language || "",
        !!e.block.metadata?.richContent
      ],
      async () => {
        const c = ++l;
        if (i.value = e.block.content, !(e.block.metadata?.richContent || !e.block.metadata?.rawCode))
          try {
            const s = await import("highlight.js"), m = s.default || s, n = e.block.metadata.rawCode, u = String(e.block.metadata.language || "").toLowerCase();
            let f = "";
            u && u !== "code" && m.getLanguage?.(u) ? f = m.highlight(n, { language: u }).value : f = m.highlightAuto(n).value, c === l && (i.value = ge(f));
          } catch {
            i.value = e.block.content;
          }
      },
      { immediate: !0 }
    );
    const o = (c) => {
      c && navigator.clipboard.writeText(c).then(() => {
        a.value = !0, setTimeout(() => {
          a.value = !1;
        }, 2e3);
      }).catch((s) => {
        console.error("Failed to copy: ", s), e.notifyError?.("複製失敗", "無法複製內容");
      });
    };
    return (c, s) => (r(), d("div", {
      class: O([
        "code-block-container rounded-lg overflow-hidden border border-gray-200 dark:border-dark-200 bg-white dark:bg-dark-100 shadow-sm relative group font-sans text-left transition-colors",
        t.index === 0 ? "mt-0" : "mt-2",
        t.index === t.blocksCount - 1 ? "mb-0" : "mb-4"
      ]),
      style: le({ marginLeft: t.block.metadata?.indent ? `${t.block.metadata.indent}ch` : "0" })
    }, [
      b("div", Ot, [
        b("div", Wt, [
          s[1] || (s[1] = b("div", { class: "flex gap-1.5 shrink-0 opacity-80" }, [
            b("div", { class: "w-2.5 h-2.5 rounded-full bg-[#ff5f56]" }),
            b("div", { class: "w-2.5 h-2.5 rounded-full bg-[#ffbd2e]" }),
            b("div", { class: "w-2.5 h-2.5 rounded-full bg-[#27c93f]" })
          ], -1)),
          b("span", Dt, L(t.block.metadata?.language || (t.block.metadata?.richContent ? "TEXT" : "CODE")), 1)
        ]),
        b("button", {
          onClick: s[0] || (s[0] = (m) => o(t.block.metadata?.rawCode)),
          class: "copy-btn text-gray-400 dark:text-gray-400 hover:text-gray-700 dark:hover:text-white transition-all inline-flex items-center justify-center gap-1.5 text-[11px] font-bold h-7 px-3 rounded hover:bg-black/5 dark:hover:bg-white/10 active:scale-95 shrink-0"
        }, [
          a.value ? (r(), d(S, { key: 0 }, [
            P(U, {
              name: "Check",
              size: t.block.metadata?.richContent ? 13 : 14,
              class: "text-green-500"
            }, null, 8, ["size"]),
            s[2] || (s[2] = b("span", { class: "text-green-500 whitespace-nowrap" }, "已複製", -1))
          ], 64)) : (r(), d(S, { key: 1 }, [
            P(U, {
              name: "Copy",
              size: t.block.metadata?.richContent ? 13 : 14
            }, null, 8, ["size"]),
            s[3] || (s[3] = b("span", { class: "whitespace-nowrap" }, "複製", -1))
          ], 64))
        ])
      ]),
      b("div", {
        class: O([
          "w-full m-0 p-4! overflow-x-auto text-[12px] font-mono leading-normal custom-scrollbar bg-transparent border-none block text-gray-700 dark:text-dark-text selection:bg-blue-100 dark:selection:bg-white/20",
          t.block.metadata?.richContent ? "rich-text-content" : "hljs hljs-pre"
        ])
      }, [
        t.block.metadata?.richContent ? (r(), A(ve, {
          key: 0,
          blocks: t.block.metadata.richContent,
          isCompact: !0,
          "access-token": t.accessToken,
          "asset-base-url": t.assetBaseUrl,
          "download-base-url": t.downloadBaseUrl,
          "notify-error": t.notifyError
        }, null, 8, ["blocks", "access-token", "asset-base-url", "download-base-url", "notify-error"])) : (r(), d("div", Ht, [
          (r(!0), d(S, null, W(i.value, (m, n) => (r(), A(Q, {
            key: n,
            node: m,
            "access-token": t.accessToken,
            "asset-base-url": t.assetBaseUrl,
            "download-base-url": t.downloadBaseUrl
          }, null, 8, ["node", "access-token", "asset-base-url", "download-base-url"]))), 128))
        ]))
      ], 2)
    ], 6));
  }
}), qt = /* @__PURE__ */ ae(Gt, [["__scopeId", "data-v-a3d8aaa4"]]), Kt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: qt
}, Symbol.toStringTag, { value: "Module" })), we = async (t, e = 2) => {
  const a = t.cloneNode(!0), i = t.getBoundingClientRect();
  a.setAttribute("width", i.width.toString()), a.setAttribute("height", i.height.toString());
  const l = new XMLSerializer().serializeToString(a), o = document.createElement("canvas"), c = o.getContext("2d");
  o.width = i.width * e, o.height = i.height * e, c && (c.fillStyle = "white", c.fillRect(0, 0, o.width, o.height), c.scale(e, e));
  const s = new Blob([l], { type: "image/svg+xml;charset=utf-8" }), m = URL.createObjectURL(s);
  return new Promise((n, u) => {
    const f = new Image();
    f.onload = () => {
      c?.drawImage(f, 0, 0), URL.revokeObjectURL(m), n(o);
    }, f.onerror = (p) => {
      URL.revokeObjectURL(m), u(p);
    }, f.src = m;
  });
}, Ft = async (t) => {
  const e = await we(t);
  return new Promise((a, i) => {
    e.toBlob(async (l) => {
      if (l)
        try {
          const o = [new ClipboardItem({ [l.type]: l })];
          await navigator.clipboard.write(o), a();
        } catch (o) {
          i(o);
        }
      else
        i(new Error("無法產生圖片 Blob"));
    }, "image/png");
  });
}, Xt = async (t, e = "diagram") => {
  const i = (await we(t, 3)).toDataURL("image/png"), l = document.createElement("a");
  l.href = i, l.download = `${e}-${(/* @__PURE__ */ new Date()).getTime()}.png`, document.body.appendChild(l), l.click(), document.body.removeChild(l);
}, Vt = (t, e = "diagram") => {
  const a = new XMLSerializer().serializeToString(t), i = new Blob([a], { type: "image/svg+xml;charset=utf-8" }), l = URL.createObjectURL(i), o = document.createElement("a");
  o.href = l, o.download = `${e}-${(/* @__PURE__ */ new Date()).getTime()}.svg`, document.body.appendChild(o), o.click(), document.body.removeChild(o), URL.revokeObjectURL(l);
}, Zt = { class: "code-header flex justify-between items-center h-10 px-4 bg-gray-50 dark:bg-dark-200 border-b border-gray-200 dark:border-white/5 no-select" }, Yt = { class: "flex items-center gap-2.5 shrink-0" }, _t = { class: "flex items-center gap-1.5 shrink-0" }, Jt = {
  key: 0,
  class: "flex items-center gap-1 mr-2 border-r border-gray-200 dark:border-white/5 pr-2"
}, Qt = {
  key: 0,
  class: "flex flex-col items-center gap-3 py-8"
}, en = {
  key: 1,
  class: "flex flex-col items-center gap-3 py-8 text-red-500"
}, tn = { class: "mt-2 p-3 bg-red-50 dark:bg-red-900/10 rounded text-[10px] font-mono whitespace-pre-wrap max-w-full italic text-left" }, nn = ["innerHTML"], an = { class: "flex flex-col gap-2 mb-2 pb-2 border-b border-white/20" }, rn = ["innerHTML"], sn = /* @__PURE__ */ Z({
  __name: "MermaidBlock",
  props: {
    block: {},
    index: {},
    blocksCount: {},
    notifySuccess: { type: Function },
    notifyError: { type: Function }
  },
  setup(t) {
    const e = t, a = H(""), i = H(!0), l = H(""), o = H(!1), c = H(!1), s = H(null), m = H(1), n = H({ x: 0, y: 0 }), u = H(!1), f = H({ x: 0, y: 0 }), p = H(0), w = H(1);
    fe.initialize({
      startOnLoad: !1,
      theme: document.documentElement.classList.contains("dark") ? "dark" : "default",
      securityLevel: "loose"
    });
    const h = async () => {
      if (!e.block.metadata?.rawCode) {
        i.value = !1, l.value = "無效的圖表代碼";
        return;
      }
      i.value = !0, l.value = "";
      try {
        const k = `mermaid-${Math.random().toString(36).substr(2, 9)}`, { svg: g } = await fe.render(k, e.block.metadata.rawCode);
        a.value = g;
      } catch (k) {
        console.error("Mermaid render error:", k), l.value = k instanceof Error ? k.message : "渲染過程中發生錯誤";
      } finally {
        i.value = !1;
      }
    }, x = () => {
      i.value || l.value || (c.value = !0, $(), Ie(() => {
        s.value && s.value.focus();
      }));
    }, y = () => {
      c.value = !1;
    }, v = (k) => {
      const D = k.deltaY > 0 ? -0.1 : 0.1;
      m.value = Math.max(0.1, Math.min(10, m.value + D));
    }, T = (k) => {
      u.value = !0, f.value = { x: k.clientX - n.value.x, y: k.clientY - n.value.y };
    }, M = (k) => {
      u.value && (n.value = {
        x: k.clientX - f.value.x,
        y: k.clientY - f.value.y
      });
    }, I = () => {
      u.value = !1;
    }, N = (k, g) => Math.sqrt(
      Math.pow(g.clientX - k.clientX, 2) + Math.pow(g.clientY - k.clientY, 2)
    ), q = (k) => {
      if (k.touches.length === 1) {
        u.value = !0;
        const g = k.touches[0];
        g && (f.value = { x: g.clientX - n.value.x, y: g.clientY - n.value.y });
      } else if (k.touches.length === 2) {
        u.value = !1;
        const g = k.touches[0], D = k.touches[1];
        g && D && (p.value = N(g, D), w.value = m.value);
      }
    }, z = (k) => {
      if (k.touches.length === 1 && u.value) {
        const g = k.touches[0];
        g && (n.value = { x: g.clientX - f.value.x, y: g.clientY - f.value.y });
      } else if (k.touches.length === 2) {
        const g = k.touches[0], D = g && k.touches[1];
        if (g && D && p.value > 0) {
          const te = N(g, D) / p.value;
          m.value = Math.max(0.1, Math.min(10, w.value * te));
        }
      }
    }, E = () => {
      u.value = !1, p.value = 0;
    }, R = () => {
      m.value = Math.min(10, m.value + 0.5);
    }, C = () => {
      m.value = Math.max(0.1, m.value - 0.5);
    }, $ = () => {
      m.value = 1, n.value = { x: 0, y: 0 };
    }, B = async (k) => {
      try {
        const g = document.querySelector(k);
        if (!(g instanceof SVGElement)) return;
        await Ft(g), e.notifySuccess?.("複製成功", "圖表已作為圖片複製到剪貼簿");
      } catch (g) {
        console.error("Copy error:", g), e.notifyError?.("複製失敗", "無法將圖表複製到剪貼簿");
      }
    }, j = async (k) => {
      try {
        const g = document.querySelector(k);
        if (!(g instanceof SVGElement)) return;
        await Xt(g, `diagram-${e.index}`), e.notifySuccess?.("下載成功", "圖表已作為 PNG 檔案下載");
      } catch (g) {
        console.error("Download PNG error:", g), e.notifyError?.("下載失敗", "無法產生 PNG 檔案");
      }
    }, X = (k) => {
      try {
        const g = document.querySelector(k);
        if (!(g instanceof SVGElement)) return;
        Vt(g, `diagram-${e.index}`), e.notifySuccess?.("下載成功", "圖表已作為 SVG 檔案下載");
      } catch (g) {
        console.error("Download SVG error:", g), e.notifyError?.("下載失敗", "無法產生 SVG 檔案");
      }
    };
    Se(() => {
      h();
    }), ce(() => {
      y();
    }), de(() => e.block.metadata?.rawCode, () => {
      h();
    });
    const V = (k) => {
      k && navigator.clipboard.writeText(k).then(() => {
        o.value = !0, setTimeout(() => {
          o.value = !1;
        }, 2e3);
      }).catch((g) => {
        console.error("Failed to copy: ", g);
      });
    };
    return (k, g) => (r(), d("div", {
      class: O([
        "mermaid-block-container rounded-lg overflow-hidden border border-gray-200 dark:border-dark-200 bg-white dark:bg-dark-100 shadow-sm relative group transition-colors",
        t.index === 0 ? "mt-0" : "mt-2",
        t.index === t.blocksCount - 1 ? "mb-0" : "mb-4"
      ]),
      style: le({ marginLeft: t.block.metadata?.indent ? `${t.block.metadata.indent}ch` : "0" })
    }, [
      b("div", Zt, [
        b("div", Yt, [
          P(U, {
            name: "BarChart3",
            size: 14,
            class: "text-blue-500"
          }),
          g[8] || (g[8] = b("span", { class: "text-[11px] font-bold uppercase text-gray-500 tracking-wider whitespace-nowrap" }, " MERMAID ", -1))
        ]),
        b("div", _t, [
          !i.value && !l.value ? (r(), d("div", Jt, [
            b("button", {
              onClick: g[0] || (g[0] = Y((D) => B(".mermaid-target svg"), ["stop"])),
              class: "text-gray-400 hover:text-blue-500 transition-all inline-flex items-center justify-center gap-1.5 h-7 px-2 rounded hover:bg-gray-200 dark:hover:bg-white/10 active:scale-95",
              title: "複製圖片"
            }, [
              P(U, {
                name: "Copy",
                size: 14
              }),
              g[9] || (g[9] = b("span", { class: "text-[11px] font-bold whitespace-nowrap hidden md:inline" }, "複製圖片", -1))
            ]),
            b("button", {
              onClick: g[1] || (g[1] = Y((D) => j(".mermaid-target svg"), ["stop"])),
              class: "text-gray-400 hover:text-blue-500 transition-all inline-flex items-center justify-center gap-1.5 h-7 px-2 rounded hover:bg-gray-200 dark:hover:bg-white/10 active:scale-95",
              title: "下載 PNG"
            }, [
              P(U, {
                name: "Image",
                size: 14
              }),
              g[10] || (g[10] = b("span", { class: "text-[11px] font-bold whitespace-nowrap hidden md:inline" }, "下載圖片", -1))
            ])
          ])) : F("", !0),
          b("button", {
            onClick: g[2] || (g[2] = (D) => V(t.block.metadata?.rawCode)),
            class: "copy-btn text-gray-400 hover:text-blue-500 dark:hover:text-white transition-all inline-flex items-center justify-center gap-1.5 text-[11px] font-bold h-7 px-3 rounded hover:bg-gray-200 dark:hover:bg-white/10 active:scale-95 shrink-0",
            title: "複製 Mermaid 代碼"
          }, [
            o.value ? (r(), d(S, { key: 0 }, [
              P(U, {
                name: "Check",
                size: 14,
                class: "text-green-500"
              }),
              g[11] || (g[11] = b("span", { class: "text-green-500 whitespace-nowrap" }, "已複製", -1))
            ], 64)) : (r(), d(S, { key: 1 }, [
              P(U, {
                name: "Copy",
                size: 14
              }),
              g[12] || (g[12] = b("span", { class: "whitespace-nowrap" }, "複製代碼", -1))
            ], 64))
          ])
        ])
      ]),
      b("div", {
        class: "p-6 overflow-x-auto flex justify-center bg-white dark:bg-dark-100 cursor-zoom-in group/inner relative",
        onClick: x
      }, [
        i.value ? (r(), d("div", Qt, [
          P(U, {
            name: "Loader2",
            size: 24,
            class: "animate-spin text-gray-400"
          }),
          g[13] || (g[13] = b("span", { class: "text-xs text-gray-400" }, "正在渲染圖表...", -1))
        ])) : l.value ? (r(), d("div", en, [
          P(U, {
            name: "AlertCircle",
            size: 24
          }),
          g[14] || (g[14] = b("span", { class: "text-xs" }, "圖表渲染失敗", -1)),
          b("pre", tn, L(l.value), 1)
        ])) : (r(), d("div", {
          key: 2,
          class: "mermaid-target w-full flex justify-center",
          innerHTML: a.value
        }, null, 8, nn)),
        !i.value && !l.value ? (r(), d("div", {
          key: 3,
          class: "absolute bottom-3 right-3 opacity-0 group-hover/inner:opacity-100 transition-all bg-blue-500 hover:bg-blue-600 text-white px-3 py-1.5 rounded-lg shadow-lg flex items-center gap-2 cursor-pointer active:scale-95 z-10",
          onClick: Y(x, ["stop"])
        }, [
          P(U, {
            name: "Search",
            size: 14
          }),
          g[15] || (g[15] = b("span", { class: "text-xs font-bold whitespace-nowrap" }, "點擊放大", -1))
        ])) : F("", !0)
      ]),
      (r(), A(Be, { to: "body" }, [
        P(Le, { name: "fade" }, {
          default: ee(() => [
            c.value ? (r(), d("div", {
              key: 0,
              class: "fixed inset-0 z-9999 bg-black/90 backdrop-blur-sm flex items-center justify-center outline-none",
              onClick: y,
              onKeydown: ze(y, ["esc"]),
              tabindex: "0",
              ref_key: "overlayRef",
              ref: s
            }, [
              b("button", {
                class: "absolute top-6 right-6 z-20 w-10 h-10 flex items-center justify-center bg-gray-900/80 hover:bg-gray-800 backdrop-blur-md rounded-full text-white transition-all shadow-2xl border border-white/20 group",
                onClick: Y(y, ["stop"]),
                title: "關閉"
              }, [
                P(U, {
                  name: "X",
                  size: 24,
                  class: "group-hover:scale-110 transition-transform"
                })
              ]),
              b("div", {
                class: "absolute bottom-6 right-6 sm:bottom-8 sm:right-8 flex flex-col gap-3 sm:gap-2 z-10",
                onClick: g[6] || (g[6] = Y(() => {
                }, ["stop"]))
              }, [
                b("div", an, [
                  b("button", {
                    class: "w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gray-900/80 hover:bg-gray-800 backdrop-blur-md rounded-full text-white transition-all shadow-2xl border border-white/20 group",
                    title: "複製圖片",
                    onClick: g[3] || (g[3] = (D) => B(".mermaid-zoomed-target svg"))
                  }, [
                    P(U, {
                      name: "Copy",
                      size: 24,
                      class: "group-hover:scale-110 transition-transform"
                    })
                  ]),
                  b("button", {
                    class: "w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gray-900/80 hover:bg-gray-800 backdrop-blur-md rounded-full text-white transition-all shadow-2xl border border-white/20 group",
                    title: "下載 PNG",
                    onClick: g[4] || (g[4] = (D) => j(".mermaid-zoomed-target svg"))
                  }, [
                    P(U, {
                      name: "Image",
                      size: 24,
                      class: "group-hover:scale-110 transition-transform"
                    })
                  ]),
                  b("button", {
                    class: "w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gray-900/80 hover:bg-gray-800 backdrop-blur-md rounded-full text-white transition-all shadow-2xl border border-white/20 group",
                    title: "下載 SVG",
                    onClick: g[5] || (g[5] = (D) => X(".mermaid-zoomed-target svg"))
                  }, [
                    P(U, {
                      name: "Download",
                      size: 24,
                      class: "group-hover:scale-110 transition-transform"
                    })
                  ])
                ]),
                b("button", {
                  class: "w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gray-900/80 hover:bg-gray-800 backdrop-blur-md rounded-full text-white transition-all shadow-2xl border border-white/20 group",
                  title: "放大",
                  onClick: R
                }, [
                  P(U, {
                    name: "Plus",
                    size: 24,
                    class: "group-hover:scale-110 transition-transform"
                  })
                ]),
                b("button", {
                  class: "w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gray-900/80 hover:bg-gray-800 backdrop-blur-md rounded-full text-white transition-all shadow-2xl border border-white/20 group",
                  title: "縮小",
                  onClick: C
                }, [
                  P(U, {
                    name: "Minus",
                    size: 24,
                    class: "group-hover:scale-110 transition-transform"
                  })
                ]),
                b("button", {
                  class: "w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gray-900/80 hover:bg-gray-800 backdrop-blur-md rounded-full text-white transition-all shadow-2xl border border-white/20 group",
                  title: "重置",
                  onClick: $
                }, [
                  P(U, {
                    name: "Maximize",
                    size: 24,
                    class: "group-hover:scale-110 transition-transform"
                  })
                ])
              ]),
              b("div", {
                class: "w-full h-full flex items-center justify-center select-none overflow-hidden",
                onClick: g[7] || (g[7] = Y(() => {
                }, ["stop"])),
                onWheel: Y(v, ["prevent"]),
                onMousedown: T,
                onMousemove: M,
                onMouseup: I,
                onMouseleave: I,
                onTouchstart: q,
                onTouchmove: z,
                onTouchend: E
              }, [
                b("div", {
                  class: O(["zoomed-mermaid-container bg-white dark:bg-dark-100 p-4 md:p-10 rounded-2xl shadow-2xl flex items-center justify-center pointer-events-none", { "transition-transform duration-200 ease-out": !u.value }]),
                  style: le({
                    transform: `translate(${n.value.x}px, ${n.value.y}px) scale(${m.value})`,
                    width: "90vw",
                    maxWidth: "1200px",
                    height: "auto",
                    maxHeight: "85vh"
                  })
                }, [
                  b("div", {
                    class: "mermaid-zoomed-target w-full h-full flex items-center justify-center",
                    innerHTML: a.value
                  }, null, 8, rn)
                ], 6)
              ], 32)
            ], 544)) : F("", !0)
          ]),
          _: 1
        })
      ]))
    ], 6));
  }
}), on = /* @__PURE__ */ ae(sn, [["__scopeId", "data-v-062d8cc1"]]), ln = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: on
}, Symbol.toStringTag, { value: "Module" })), cn = ["innerHTML"], dn = {
  key: 1,
  class: "text-red-500 font-mono text-xs"
}, un = /* @__PURE__ */ Z({
  __name: "KatexBlock",
  props: {
    block: {},
    index: {},
    blocksCount: {}
  },
  setup(t) {
    const e = t, a = G(() => e.block.metadata?.rawCode || ""), i = G(() => {
      if (!a.value) return "";
      try {
        return Ve.renderToString(a.value, {
          displayMode: !0,
          throwOnError: !1,
          strict: !1
        });
      } catch (l) {
        return console.error("KaTeX rendering error:", l), "";
      }
    });
    return (l, o) => (r(), d("div", {
      class: O([
        "katex-block-container mb-4 p-4 rounded-lg bg-gray-50 dark:bg-dark-100/30 border border-gray-100 dark:border-dark-200/50 flex justify-center overflow-x-auto custom-scrollbar",
        t.index === 0 ? "mt-0" : "mt-4",
        t.index === t.blocksCount - 1 ? "mb-0" : "mb-4"
      ]),
      style: le({ marginLeft: t.block.metadata?.indent ? `${t.block.metadata.indent}ch` : "0" })
    }, [
      i.value ? (r(), d("div", {
        key: 0,
        class: "katex-display-wrapper",
        innerHTML: i.value
      }, null, 8, cn)) : (r(), d("div", dn, L(a.value), 1))
    ], 6));
  }
}), hn = /* @__PURE__ */ ae(un, [["__scopeId", "data-v-c1688f3f"]]), fn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: hn
}, Symbol.toStringTag, { value: "Module" }));
export {
  qt as CodeBlock,
  hn as KatexBlock,
  wn as LightMarkdownRenderer,
  U as LucideIcon,
  ht as MAX_LIGHT_MARKDOWN_INLINE_PASSES,
  kn as MarkdownAdaptiveRenderer,
  ve as MarkdownRenderer,
  Q as MarkdownResult,
  on as MermaidBlock,
  Ft as copySvgAsImage,
  pe as createInlineCodePattern,
  ye as createMarkdownLinkPattern,
  Xt as downloadSvgAsPng,
  Vt as downloadSvgAsSvg,
  xn as hasMarkdownFence,
  ft as parseLightMarkdownBlocks,
  ne as parseLightMarkdownInline,
  ue as parseMarkdown,
  ke as parseMarkdownFenceLine,
  xe as parseMarkdownLink,
  vn as safeLightMarkdownHref,
  be as safeMarkdownHref,
  we as svgToCanvas
};
